// @flow
import { 
  UPDATE_TARGET_LIST, 
  UPDATE_TARGET,
  UPDATE_COMPANY,
  UPDATE_COMPANY_LIST,
  UPDATE_TARGET_STATUS
} from '../../actions/targets'
import type {
  UPDATE_LIST_TARGETS_TYPE,
  UPDATE_TARGET_TYPE,
  UPDATE_COMPANY_TYPE,
  UPDATE_COMPANY_LIST_TYPE,
  UPDATE_TARGET_STATUS_TYPE
} from '../../actions/targets'

type State = {
  targets: string[],
  target: string,
  company: Object,
  companyList: Object[],
  isFetching: boolean
}

const initialState: State = {
  targets: [],
  target: '',
  company: {},
  companyList: [],
  isFetching: true,
  error: null
}

type Action = 
  | UPDATE_LIST_TARGETS_TYPE 
  | UPDATE_TARGET_TYPE 
  | UPDATE_COMPANY_TYPE 
  | UPDATE_COMPANY_LIST_TYPE
  | UPDATE_TARGET_STATUS_TYPE

export default function targetsReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_TARGET_LIST: {
      const { targets } = action.payload
      return {
        ...state,
        targets
      }
    }
    case UPDATE_TARGET: {
      const { target } = action.payload
      return {
        ...state,
        target
      }
    }
    case UPDATE_COMPANY: {
      const { company } = action.payload
      return {
        ...state,
        company
      }
    }
    case UPDATE_COMPANY_LIST: {
      const { company } = action.payload
      const companyList = [...state.companyList, company]
      return {
        ...state,
        companyList
      }
    }
    case UPDATE_TARGET_STATUS: {
      const { isFetching, error } = action.payload
      return {
        ...state,
        isFetching,
        error
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/targets/index.js